import React, { useRef } from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  root: {
    display: 'flex'
  },
  submit: {
    display: 'none'
  }
})

function Form (props) {
  const styles = useStyles()
  const formRef = useRef()
  const { className, children, onEnterKeyPress, ...args } = props
  
  const handleSubmit = (evt) => {
    evt.preventDefault()
    if (onEnterKeyPress) {
      onEnterKeyPress(formRef && formRef.current)
    }
    return true
  }

  const boxStyle = className ? `${styles.root} ${className}` : styles.root
  return (
    <form ref={formRef} className={boxStyle} action="" onSubmit={handleSubmit} {...args}>
      { children }
      <input className={styles.submit} type="submit" />
    </form>
  )
}

export default Form